import api from '../../utils/api';
import type { PushNotificationCampaign } from '../../models/MasterAdmin/pushNotificationCampaign';

export type HealthRecordUsageByType = {
  type: string;
  count: number;
  bytes: number;
};

export type HealthRecordUserSample = {
  userId: string;
  name: string;
  phoneNumber: string;
  loginStatus: 'LOGGED_IN' | 'LOGGED_OUT';
};

export type HealthRecordUsageResponse = {
  success: boolean;
  data: {
    totalRecords: number;
    totalBytes: number;
    byType: HealthRecordUsageByType[];
    otherUserStorage?: HealthRecordUsageByType[];
    totalUsers: number;
    usersWithHealthRecordCount: number;
    usersWithoutHealthRecordCount: number;
    uploadSuccessRate?: number;
    avgUploadLatencyMs?: number;
    usersWithoutHealthRecordSample: HealthRecordUserSample[];
  };
};

export async function fetchHealthRecordUsage(): Promise<HealthRecordUsageResponse> {
  const response = await api.get('/master-admin/health-record-usage');
  return response.data;
}

export async function fetchUserHealthRecordUsage(userId: string): Promise<{
  success: boolean;
  data: {
    userId: string;
    storageLimitBytes: number;
    totalRecords: number;
    totalBytes: number;
    remainingBytes: number;
    usedPercent: number;
    byType: HealthRecordUsageByType[];
  };
}> {
  const response = await api.get(`/master-admin/health-record-usage/users/${encodeURIComponent(userId)}`);
  return response.data;
}

export async function sendHealthRecordReminder(payload: { title: string; message: string }): Promise<{
  success: boolean;
  data: {
    campaign: PushNotificationCampaign;
    usersWithoutHealthRecordCount: number;
    tokensTargeted: number;
    fcmSuccessCount: number;
    fcmFailureCount: number;
    inboxRowsInserted: number;
    message: string;
  };
}> {
  const response = await api.post('/master-admin/health-record-usage/send-notification', payload);
  return response.data;
}
